import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import moment from "moment";
import { Field } from "redux-form";
import { reduxFormInputType, selectOptionType } from "custom-prop-types";
import styles from "components/common/form-elements.scss";
import { Datepicker } from "components/common/datepicker";
import { Button } from "components/common/button";
import { GSTCalculator } from "components/documents/documents-grid/gst-calculator";
import { Checkbox } from "components/common/checkbox";
import { onChangeMapper, optionsMapper, valueMapper, MultiCreatableSelect } from "components/common/select";
import { paymentTypes } from "utils/payment-types";

export const FormButton = ({ text }) => (
  <div className={ styles["form-button"] }>
    <Button primary type="submit">{ text }</Button>
  </div>
);

FormButton.propTypes = { text: PropTypes.string.isRequired };

export const renderFormElement = (title, name, type, options = null, addFunction, accountId) => (
  <div className={ styles["fields-container"] }>
    <h4>{ title }</h4>
    <Field
      accountId={ accountId }
      addFunction={ addFunction }
      component={ componentType(type) }
      name={ name }
      options={ options }
      placeholder={ title }
    />
  </div>
);

const componentType = (type) => {
  switch (type) {
    case "text":
      return TextInput;
    case "select":
      return SelectInput;
    case "date":
      return DatePickerInput;
    case "notes":
      return NoteInput;
    case "createable":
      return CreateableSelectInput;
    default:
      return TextInput;
  }
};

const TextInput = (props) => <input { ...props.input } className={ styles.fields } placeholder={ props.placeholder } />;

TextInput.propTypes = {
  input: reduxFormInputType.isRequired,
  placeholder: PropTypes.string.isRequired
};

const SelectInput = (props) => (
  <ReactSelect
    { ...props.input }
    clearable={ false }
    onBlur={ () => props.input.onBlur(props.input.value) }
    onChange={ onChangeMapper(props.input.onChange) }
    options={ optionsMapper(props.options) }
    placeholder={ props.placeholder }
    searchable={ false }
    value={ valueMapper(props.input.value) }
  />
);

SelectInput.propTypes = {
  input: reduxFormInputType.isRequired,
  options: PropTypes.arrayOf(selectOptionType).isRequired,
  placeholder: PropTypes.string.isRequired
};

const DatePickerInput = (props) => (
  <Datepicker
    { ...props.input }
    isClearable={ false }
    onDateSelected={ (e) => { props.input.onChange(e); } }
    placeholderText="Enter a date"
    selected={ props.input.value ? moment(props.input.value) : null }
  />
);

DatePickerInput.propTypes = { input: reduxFormInputType.isRequired };

const NoteInput = (props) => <textarea { ...props.input } className={ styles.notes } />;

NoteInput.propTypes = { input: reduxFormInputType.isRequired };

const CreateableSelectInput = (props) => (
  <MultiCreatableSelect
    { ...props }
    accountId={ props.accountId }
    addFunction={ props.addFunction }
    placeholder="Choose a category..."
  />
);

CreateableSelectInput.propTypes = {
  accountId: PropTypes.string.isRequired,
  addFunction: PropTypes.func.isRequired
};

export const renderFormToggleElement = (title, name) => (
  <div className={ styles["fields-container"] }>
    <h4>{ title }</h4>
    <Field
      component={ ToggleInput }
      name={ name }
      parse={ Boolean }
    />
  </div>
);

const ToggleInput = (props) => (
  <Checkbox
    checked={ props.input.value }
    disabled={ false }
    onChange={ props.input.value ? () => props.input.onChange(false) : () => props.input.onChange(true) }
  />
);

ToggleInput.propTypes = {
  input: reduxFormInputType.isRequired
};

export const renderFormNumberElement = (title, name, min, max, step) => (
  <div className={ styles["fields-container"] }>
    <h4>{ title }</h4>
    <Field
      component={ NumberInput }
      max={ max }
      min={ min }
      name={ name }
      normalize={ normalizeNumberField }
      placeholder={ title }
      step={ step }
      type="text"
    />
  </div>
);

const normalizeNumberField = (value) => {
  if (isNaN(value)) {
    return 0;
  }
  return value;
};

const NumberInput = (props) => (
  <input
    { ...props.input }
    className={ styles.fields }
    max={ props.max }
    min={ props.min }
    placeholder={ props.placeholder }
    step={ props.step }
    type="text"
  />
);

NumberInput.defaultProps = {
  max: null,
  min: null
};

NumberInput.propTypes = {
  input: reduxFormInputType.isRequired,
  max: PropTypes.string,
  min: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired
};

export const renderFormCalculateTaxElement = (props) => (
  <div className={ styles["fields-container"] }>
    <Field
      change={ props.change }
      component={ TaxButton }
      currency={ props.currency }
      name={ "tax-button" }
      preferredCurrency={ props.preferredCurrency }
      taxRate={ props.taxRate }
      total={ props.total }
    />
  </div>
);

const TaxButton = (props) => (
  <div className={ styles.gst }>
    <GSTCalculator { ...props } />
  </div>
);

renderFormCalculateTaxElement.propTypes = {
  change: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  preferredCurrency: PropTypes.string.isRequired,
  taxRate: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

export const renderPaymentTypeElement = (formPaymentType) => {
  const className = formPaymentType.key === "credit-card" ? styles["credit-card"] : styles["other-payment"];
  return (
    <div className={ styles["fields-container"] }>
      <h4>Payment Type</h4>
      <div className={ className }>
        <Field
          component={ SelectInput }
          name={ "formPaymentType" }
          options={ paymentTypes }
          placeholder={ "Choose a payment type" }
        />
        <Field
          component={ NumberInput }
          max="9999"
          min="0"
          name={ "cardNumber" }
          placeholder={ "Last four..." }
          step="1"
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/js/components/common/form-elements.jsx